"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isUrl = _interopRequireDefault(require("is-url"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var requiredUrlPropType = function requiredUrlPropType(props, propName, componentName) {
  var value = props[propName];

  if (value == null || typeof value !== 'string' || !value.startsWith('/') && !(0, _isUrl["default"])(value)) {
    return new TypeError("Invalid URL Prop Value: ".concat(value, " for ").concat(propName, " in ").concat(componentName));
  }

  return null;
};

var urlPropType = function urlPropType(props, propName, componentName) {
  if (props[propName] == null) {
    return null;
  }

  return requiredUrlPropType(props, propName, componentName);
};

urlPropType.isRequired = requiredUrlPropType;
var _default = urlPropType;
exports["default"] = _default;